import React, {useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import * as databaseBackupActions from "../../../../redux/DatabaseBackups/actions";
import LoadingPanel from "../../../../components/LoadingPanel";

import './CreateSnapshot.scss';

const CreateSnapshot = ({onClose, onCreateSnapshot}) => {
	const [loading, setLoading] = useState(false);
	const [comments, setComments] = useState('');
	const dispatch = useDispatch();

	const createSnapshot = async () => {
		setLoading(true);
		await dispatch(databaseBackupActions.createSnapshot(comments, onClose));
	};

	// Pass the createSnapshot function to parent when it changes
	useEffect(() => {
		if (onCreateSnapshot) {
			onCreateSnapshot(createSnapshot);
		}
	}, [comments]);

	return (
		<div className="create-snapshot-container">

			{ loading && <LoadingPanel /> }

			<div className="create-snapshot-fields">
				<textarea placeholder="Comments" onChange={e => setComments(e.target.value)} value={comments} className="create-snapshot-input" />
			</div>
		</div>
	)
};

export default CreateSnapshot;